/**
 * GreetingSection -- 인사말 섹션 편집
 */

import { useInvitationStore } from '../../../stores/invitationStore.js'
import { Textarea, Input, Select } from '../../ui/index.js'
import styles from './SectionForm.module.css'

const FONT_SIZE_OPTIONS = [
  { value: 'sm', label: '작게' },
  { value: 'md', label: '보통' },
  { value: 'lg', label: '크게' },
  { value: 'xl', label: '아주 크게' },
  { value: 'custom', label: '직접 입력' },
]

export function GreetingSection() {
  const invitation = useInvitationStore((s) => s.invitation)
  const updateNested = useInvitationStore((s) => s.updateNested)
  if (!invitation) return null

  const fontSize = invitation.content?.greetingFontSize ?? 'md'

  return (
    <div className={styles.form}>
      <div className={styles.fieldGroup}>
        <div className={styles.fieldGroupTitle}>인사말</div>
        <Textarea
          label="인사말"
          value={invitation.content?.greeting ?? ''}
          onChange={(e) => updateNested('content.greeting', e.target.value)}
          placeholder="소중한 분들을 초대합니다..."
          rows={5}
        />
      </div>

      <div className={styles.fieldGroup}>
        <div className={styles.fieldGroupTitle}>폰트 크기</div>
        <Select
          label="인사말 폰트 크기"
          options={FONT_SIZE_OPTIONS}
          value={fontSize}
          onChange={(e) => updateNested('content.greetingFontSize', e.target.value)}
        />
        {fontSize === 'custom' && (
          <Input
            label="크기 (px)"
            type="number"
            value={invitation.content?.greetingFontSizeCustom?.toString() ?? ''}
            onChange={(e) =>
              updateNested('content.greetingFontSizeCustom', e.target.value ? Number(e.target.value) : undefined)
            }
            placeholder="16"
          />
        )}
      </div>

    </div>
  )
}
